import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FileImportModal from '../Shared/FileImportModal';
import { importOrdersFile } from 'redux/slices/ordersImportSlice';

const ImportOrderModal = ({ open, onClose, t, onImportComplete }) => {
  const dispatch = useDispatch();
  const { importErrors } = useSelector((state) => state.ordersImport || { importErrors: {} });

  const handleImportOrders = async (file, date, departure) => {
    try {
      const response = await dispatch(importOrdersFile(file, date, departure, t));
      return response.payload || response;
    } catch (error) {
      console.error("Customer import error:", error);
      return { success: false, errors: {} };
    }
  };
  return (
    <FileImportModal
      open={open}
      onClose={onClose}
      t={t}
      onImportComplete={onImportComplete}
      onImport={handleImportOrders}
      showDateDeparture={true}
      title="Import Orders"
      description="Upload the file containing order data. The file must be an Excel workbook (.xlsx or .xls) that follows the template below."
      templateUrl="/assets/templates/Aufträge Import Vorlage.xlsx"
      templateName="Aufträge import vorlage"
      acceptedFileTypes={[
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ".xlsx",
        ".xls",
      ]}
      errorMessage="atbas_orders_import_error_heading"
      importErrors={importErrors}
    />
  );
};

export default ImportOrderModal;